import { useCallback, useMemo, useState } from 'react';
import { useGetConnectionPathsQuery } from '../../../../services/connectionPathsV2';

export const EXPAND_ALL_STORAGE_KEY = 'introPaths.expandAll';

const readExpandAll = () => {
  try {
    return window.localStorage?.getItem(EXPAND_ALL_STORAGE_KEY) === 'expanded' ? 'expanded' : 'collapsed';
  } catch {
    return 'collapsed';
  }
};

const writeExpandAll = (value) => {
  try {
    window.localStorage?.setItem(EXPAND_ALL_STORAGE_KEY, value);
  } catch {
    /* localStorage may be disabled; persistence is best-effort */
  }
};

export function useIntroPaths({ contact, hasRelationshipStrength = false }) {
  const {
    data = [],
    isLoading,
    isSuccess,
  } = useGetConnectionPathsQuery({
    contactId: contact.id,
    withRelationshipStrength: hasRelationshipStrength,
  });
  const [showAll, setShowAll] = useState(false);
  const [expandAll, setExpandAllState] = useState(readExpandAll);

  const setExpandAll = useCallback((value) => {
    const next = value === 'expanded' ? 'expanded' : 'collapsed';
    setExpandAllState(next);
    writeExpandAll(next);
  }, []);

  const { initialCount, itemsToRender, hasMore } = useMemo(() => {
    const initial = Math.min(5, data.length);
    const visibleItems = showAll ? data : data.slice(0, initial);
    const more = data.length > initial;
    return { initialCount: initial, itemsToRender: visibleItems, hasMore: more };
  }, [data, showAll]);

  return {
    data: data ?? [],
    isLoading,
    isSuccess,
    showAll,
    setShowAll,
    initialCount,
    itemsToRender,
    hasMore,
    expandAll,
    setExpandAll,
  };
}
